var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"workcall",class:{'workbenchBorder':_vm.workbenchBorder},attrs:{"id":"workbench","draggable":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }